import { CapoPlugin } from "/usr/src/app/packages/all-inclusive-app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];